/**
 * Catálogo alinhado ao menu lateral do CRM (itens e submenus).
 * key → support/supportAffiliates/{uid}/modules/{key}
 * parentKey: null = item principal; preenchido = submenu daquele módulo.
 * available: true → switch editável; false → desabilitado até implementação no router/nav.
 * kind: 'tab' → submenu listado como aba sem rota própria (abas internas de um modal/tela).
 */
export const CRM_MODULES = Object.freeze([
  { section: 'Menu', key: 'clients', label: 'Clientes', description: 'Área de clientes.', available: false, parentKey: null },
  { section: 'Menu', key: 'clientsDashboard', label: 'Dashboard', description: 'Submenu de Clientes.', available: true, parentKey: 'clients' },
  { section: 'Menu', key: 'clientsGeral', label: 'Geral', description: 'Submenu de Clientes.', available: false, parentKey: 'clients' },
  { section: 'Menu', key: 'clientsCancelados', label: 'Cancelados', description: 'Submenu de Clientes.', available: false, parentKey: 'clients' },
  { section: 'Menu', key: 'clientsScore', label: 'Score', description: 'Submenu de Clientes.', available: true, parentKey: 'clients' },
  { section: 'Menu', key: 'clientsUpsell', label: 'Upsell', description: 'Oportunidades de upsell na área de clientes.', available: true, parentKey: 'clients' },
  { section: 'Menu', key: 'clientsRemoveMarked', label: 'Excluir clientes marcados', description: 'Apaga clientes já marcados como excluídos.', available: true, parentKey: 'clients' },

  { section: 'Menu', key: 'cancelamentos', label: 'Cancelamentos', description: 'Dashboard, lista e logs de auto cancelamento.', available: true, parentKey: null },

  { section: 'Menu', key: 'finance', label: 'Financeiro', description: 'Contratos e faturamento.', available: false, parentKey: null },
  { section: 'Menu', key: 'financeContratos', label: 'Contratos', description: 'Submenu de Financeiro.', available: true, parentKey: 'finance' },
  { section: 'Menu', key: 'financeExcedentes', label: 'Excedentes', description: 'Submenu de Financeiro.', available: true, parentKey: 'finance' },

  { section: 'Menu', key: 'autonomous', label: 'Autônomos', description: 'Upsells e self-service.', available: false, parentKey: null },
  { section: 'Menu', key: 'autonomousUpsells', label: 'Upsells', description: 'Acompanhamento de upsells autônomos.', available: true, parentKey: 'autonomous' },
  { section: 'Menu', key: 'autonomousSelfService', label: 'Self-service', description: 'Analítico do self-service.', available: true, parentKey: 'autonomous' },

  { section: 'Menu', key: 'aplicativos', label: 'Aplicativos', description: 'Gestão de aplicativos.', available: true, parentKey: null },
  { section: 'Menu', key: 'aplicativosProgress', label: 'Progresso', description: 'Aba Progresso do app: etapas, links das lojas e certificado manual.', available: true, parentKey: 'aplicativos', kind: 'tab' },
  { section: 'Menu', key: 'aplicativosRequests', label: 'Solicitações de ajuste', description: 'Aba Solicitações: status e comentários dos ajustes pedidos pelo cliente.', available: true, parentKey: 'aplicativos', kind: 'tab' },
  { section: 'Menu', key: 'aplicativosBranding', label: 'Identidade visual', description: 'Aba Identidade visual: upload de vetores, certificado e imagens da loja.', available: true, parentKey: 'aplicativos', kind: 'tab' },
  { section: 'Menu', key: 'npsSurveys', label: 'Pesquisa NPS', description: 'Pesquisas de satisfação.', available: true, parentKey: null },
  { section: 'Menu', key: 'academyHub', label: 'AcademyHub', description: 'Conteúdo e analytics.', available: true, parentKey: null },

  { section: 'Menu', key: 'servers', label: 'Servidores', description: 'Monitoramento de servidores.', available: false, parentKey: null },
  { section: 'Menu', key: 'serversProcessos', label: 'Processos', description: 'Submenu de Servidores.', available: true, parentKey: 'servers' },
  { section: 'Menu', key: 'serversXml', label: 'Fila de XML', description: 'Submenu de Servidores.', available: true, parentKey: 'servers' },
  { section: 'Menu', key: 'serversFirebaseCosts', label: 'Custos Firebase', description: 'Submenu de Servidores.', available: true, parentKey: 'servers' },
  { section: 'Menu', key: 'serversConnect', label: 'Servidor Connect', description: 'Submenu de Servidores.', available: true, parentKey: 'servers' },

  { section: 'Comercial', key: 'commercial', label: 'Leads', description: 'Leads para acompanhamento do comercial.', available: true, parentKey: null },

  { section: 'Relacionamento', key: 'wallet', label: 'Carteiras', description: 'Carteiras de clientes.', available: true, parentKey: null },

  { section: 'Suporte', key: 'supportDashboard', label: 'Dashboard', description: 'Dashboard da área de suporte.', available: true, parentKey: null },
  { section: 'Suporte', key: 'bugReport', label: 'Chamados', description: 'Bug report e chamados.', available: true, parentKey: null },

  { section: 'Marketing', key: 'leads', label: 'Leads', description: 'Funil e gestão de leads.', available: true, parentKey: null },
  { section: 'Marketing', key: 'landingPage', label: 'Landing page', description: 'Formulários e landing pages.', available: true, parentKey: null },
  { section: 'Marketing', key: 'campaigns', label: 'Modais internos', description: 'Dados dos modais internos de campanha.', available: true, parentKey: null },
  { section: 'Marketing', key: 'businessPlan', label: 'Business Plan', description: 'Metas vs. realizado do funil comercial e MRR.', available: true, parentKey: null },

  { section: 'Marketing', key: 'affiliatesDashboard', label: 'MoneyHub — Dashboard', description: 'Indicadores e gráficos do MoneyHub.', available: true, parentKey: null },
  { section: 'Marketing', key: 'affiliatesFinance', label: 'MoneyHub — Afiliados', description: 'Lista, comissões e pagamentos do MoneyHub.', available: true, parentKey: null },
  { section: 'Marketing', key: 'affiliatesAddIndication', label: 'Adicionar indicações', description: 'Vincular indicações manualmente, sem passar pela HubSpot.', available: true, parentKey: 'affiliatesFinance' },
  { section: 'Marketing', key: 'affiliatesPlans', label: 'MoneyHub — Planos', description: 'Planos de comissão do MoneyHub.', available: true, parentKey: null },
  { section: 'Marketing', key: 'affiliatesMarketing', label: 'MoneyHub — Anúncios', description: 'Biblioteca de anúncios do MoneyHub.', available: true, parentKey: null },
  { section: 'Marketing', key: 'coupons', label: 'Cupons', description: 'Criar e acompanhar cupons do self-service.', available: true, parentKey: null }
])

export const CONFIGURABLE_MODULE_KEYS = [...new Set(
  CRM_MODULES.filter((m) => m.available).map((m) => m.key)
)]

const UNIQUE_MODULE_KEYS = [...new Set(CRM_MODULES.map((m) => m.key))]

export function buildEmptyModulesState () {
  return UNIQUE_MODULE_KEYS.reduce((acc, key) => {
    acc[key] = false
    return acc
  }, {})
}

export function modulesFromStored (stored = {}) {
  const modules = buildEmptyModulesState()
  UNIQUE_MODULE_KEYS.forEach((key) => {
    modules[key] = stored[key] === true
  })
  return modules
}

export function moduleRowKey (mod, index) {
  return `${mod.section}-${mod.parentKey || 'root'}-${mod.label}-${mod.key}-${index}`
}

export function isSubmenuModule (mod) {
  return !!mod.parentKey
}

/** Mapa submenu → chave modules/ (para nav/router ao marcar available: true). */
export const CRM_SUBMENU_ROUTE_KEYS = Object.freeze({
  'users:dashboard': 'clientsDashboard',
  'users:geral': 'clientsGeral',
  'users:cancelados': 'clientsCancelados',
  'users:score': 'clientsScore',
  'users:upsell': 'clientsUpsell',
  'finance:contratos': 'financeContratos',
  'finance:excedentes': 'financeExcedentes',
  'autonomos:upsells': 'autonomousUpsells',
  'autonomos:self-service': 'autonomousSelfService',
  'servers:processos': 'serversProcessos',
  'servers:xml': 'serversXml',
  'servers:firebase': 'serversFirebaseCosts',
  'servers:connect': 'serversConnect'
})

export function resolveSubmoduleEnabled (modules = {}, moduleKey) {
  if (!moduleKey) return true
  return modules[moduleKey] === true
}
